var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DomElementBuilder } from '@easydata/ui';
var DomDropDownElementBuilder = /** @class */ (function (_super) {
    __extends(DomDropDownElementBuilder, _super);
    function DomDropDownElementBuilder(parent) {
        var _this = _super.call(this, 'a', parent) || this;
        _this.attr('href', 'javascript:void(0)');
        _this.on('click', function (ev) {
            ev.preventDefault();
            _this.appear();
            return false;
        });
        return _this;
    }
    DomDropDownElementBuilder.prototype.onGetMenu = function (onGetMenu) {
        this._onGetMenu = onGetMenu;
        return this;
    };
    DomDropDownElementBuilder.prototype.onItemSelected = function (onItemSelected) {
        this._onItemSelected = onItemSelected;
        return this;
    };
    DomDropDownElementBuilder.prototype.appear = function () {
        var _this = this;
        var menu = this._onGetMenu ? this._onGetMenu() : null;
        if (menu) {
            menu.showMenu({
                anchor: this.element,
                itemSelectedCallback: function (item) {
                    if (_this._onItemSelected) {
                        _this._onItemSelected(item.id);
                    }
                    return false;
                }
            });
        }
    };
    return DomDropDownElementBuilder;
}(DomElementBuilder));
export { DomDropDownElementBuilder };
export function dropdown(parent) {
    return new DomDropDownElementBuilder(parent);
}
//# sourceMappingURL=dropdown.js.map